/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs */

const en_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floor and ceiling guards with scheduled repricing, margin protected.`)
};

const ar_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حراس الحد الأدنى والأقصى مع تسعير مجدول، والهامش محمي.`)
};

const bn_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সময়সূচি পুনর্মূল্যে নিচে-উপরে সুরক্ষা, মার্জিন নিরাপদ।`)
};

const de_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter- und Obergrenzen mit planmäßigem Repricing, Marge geschützt.`)
};

const es_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protecciones de mínimo y máximo con repreciación programada, margen protegido.`)
};

const fr_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuils plancher et plafond avec repricing planifié, marge protégée.`)
};

const pt_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteções de mínimo e máximo com reprecificação agendada, margem protegida.`)
};

const zh_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上下限保护加定时调价，利润守住。`)
};

const tr_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamanlı yeniden fiyatlamada taban ve tavan korumaları, marj güvende.`)
};

const ru_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пол и потолок с репрайсингом по расписанию, маржа защищена.`)
};

const pl_svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limity min/max z repricingiem według planu, marża chroniona.`)
};

/**
* | output |
* | --- |
* | "Floor and ceiling guards with scheduled repricing, margin protected." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_reprice_desc7 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Reprice_Desc7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
	return en_svc_ecommerce_amazon_tools_reprice_desc7(inputs)
});
export { svc_ecommerce_amazon_tools_reprice_desc7 as "svc_ecommerce-amazon-tools_REPRICE_desc" }